import { defineStyleConfig } from '@chakra-ui/react'

const underlineStyle = {
  textDecoration: 'underline',
  textUnderlineOffset: 4,
  transition: 'all .25s',
  _hover: {
    opacity: .8
  },
}

export const LinkTheme = defineStyleConfig({
  variants: {
    underline: { ...underlineStyle },
    underlinePrimary: {
      ...underlineStyle,
      textDecorationColor: 'brand.cyan'
    }
  },
  defaultProps: {
    variant: 'underline'
  }
})
